import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, KeepAlive as _KeepAlive, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["id", "aria-labelledby"]
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "icon"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["id"]
const _hoisted_9 = {
  key: 3,
  class: "btn-close",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Chiudi finestra modale",
  style: {"min-width":"44px","min-height":"44px"}
}
const _hoisted_10 = {
  key: 1,
  class: "modal-footer"
}

import { computed, onBeforeMount, onMounted, ref, Ref, watch } from "vue";
import { IModal } from "@/interfaces/components/general/IModal";
//@ts-ignore
import { Modal } from "bootstrap-italia";
import BottomSheet from "@/components/general/BottomSheet.vue";
import { IBottomSheet } from "@/interfaces/components/general/IBottomSheet";
import { idRandomGenerator } from "cdp-fe-commons-layout";


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomModal',
  props: {
    customId: { default: idRandomGenerator() },
    modal: {}
  },
  emits: ["shown", "hidden"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;
const computedModal = computed(() => props.modal);
const computedBottomSheet: Ref<IBottomSheet | undefined> = computed(() => {
  if (computedModal.value?.bottomSheet === true) {
    return {
      title: computedModal.value.title,
      content: computedModal.value.content,
      show: computedModal.value.show
    } as IBottomSheet;
  }
});

let modalBootstrap: any | null = null;

onMounted(() => {
  const modalElement: HTMLElement | null = document.getElementById(props.customId);
  if (modalElement !== null) {
    modalBootstrap = Modal.getOrCreateInstance(modalElement,
      computedModal.value.staticBackdrop ? { backdrop: "static", keyboard: false } : {});
    modalElement.addEventListener("hidden.bs.modal", function() {
      emits("hidden", props.customId);
      removeFade();
    });
    modalElement.addEventListener("shown.bs.modal", function() {
      emits("shown", props.customId);
    });
  }
});

function removeFade() {
  const fade: Element | null = document.getElementById(props.customId);
  if (fade) {
    fade.remove();
  }
}

onBeforeMount(() => {
  if (!computedModal.value.show) {
    removeFade();
  }
});

watch(computedModal, (value) => {
  if (modalBootstrap !== null && value.show) {
    modalBootstrap.toggle();
  }
}, { deep: true });

watch(() => computedModal.value.show, (value, oldValue) => {
  if (modalBootstrap !== null && oldValue != undefined && value !== oldValue) {
    modalBootstrap.toggle();
  }
});


return (_ctx: any,_cache: any) => {
  return (computedBottomSheet.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(BottomSheet, { "bottom-sheet": computedBottomSheet.value }, null, 8, ["bottom-sheet"])
      ]))
    : (computedModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass((computedModal.value.icon ? 'alert-modal ' : '') + 'modal fade'),
          id: __props.customId,
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": __props.customId+'ModalLabel',
          "aria-hidden": "true"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('modal-dialog ' + computedModal.value.dimension)
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (computedModal.value.icon)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                      _createElementVNode("use", {
                        href: '/dist/svg/sprites.svg#'+computedModal.value.icon
                      }, null, 8, _hoisted_6)
                    ]))
                  : _createCommentVNode("", true),
                (computedModal.value.title)
                  ? (_openBlock(), _createElementBlock("h1", {
                      key: 1,
                      class: "modal-title h5 no_toc",
                      id: __props.customId+'ModalLabel'
                    }, _toDisplayString(computedModal.value.title), 9, _hoisted_7))
                  : (_openBlock(), _createElementBlock("h2", {
                      key: 2,
                      class: "visually-hidden",
                      id: __props.customId+'ModalLabel'
                    }, "titolo modale", 8, _hoisted_8)),
                (computedModal.value.closable)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_9, [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("svg", { class: "icon" }, [
                        _createElementVNode("use", { href: "/dist/svg/sprites.svg#it-close" })
                      ], -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ]),
              (computedModal.value.content)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass('modal-body ' + computedModal.value.customClass ? computedModal.value.customClass : '')
                  }, [
                    (_openBlock(), _createBlock(_KeepAlive, null, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(computedModal.value.content.render), _mergeProps({
                        class: computedModal.value.content.customClass ?? ''
                      }, _toHandlers(computedModal.value.content.events ?? []), computedModal.value.content.content ?? {}), null, 16, ["class"]))
                    ], 1024))
                  ], 2))
                : _createCommentVNode("", true),
              (computedModal.value.footer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(), _createBlock(_KeepAlive, null, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(computedModal.value.footer.render), _mergeProps({
                        class: computedModal.value.footer.customClass ?? ''
                      }, _toHandlers(computedModal.value.footer.events ?? []), computedModal.value.footer.content ?? {}), null, 16, ["class"]))
                    ], 1024))
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 10, _hoisted_2))
      : _createCommentVNode("", true)
}
}

})